export const API_GET_USER_NOTIFICATION_LIST = "/gateway/api/ncm/notifications"
export const API_REMOVE_NOTIFICATION = "/gateway/api/ncm/notifications"